import React, {Component} from 'react';
import {Card} from "react-bootstrap";
import "./navigation_small_card.scss";

interface NavigationSmallCardProps {
    title: string;
    text: string;
    url ?: string;
    cta ?: string;
    focused: boolean;
    hidden: boolean;
}

class NavigationSmallCard extends Component<NavigationSmallCardProps> {
    render() {
        return (
            <Card className={this.props.focused ? "active" : ""}>
                <Card.Body>
                    <Card.Title>{this.props.title}</Card.Title>
                    {(this.props.url) ?
                        <Card.Link href={this.props.url}>{this.props.cta}</Card.Link> :
                        <Card.Text>{(this.props.cta) ? this.props.cta : null}</Card.Text>
                    }
                </Card.Body>
            </Card>
        );
    }
}

export default NavigationSmallCard;